import React, { Fragment } from "react";
import Typogaphy from "../Typography/Typography";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { AiFillTag } from "react-icons/ai";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { Link } from "react-router-dom";
import Button from "../../components/Button/Button";
import { InvoiceItemWrapper } from "./InvoiceItemStyle";
import { useRecoilValue } from "recoil";
import { crmFilteredTransaction } from "../../shared/crm-filtered-transactions";

function InvoiceItem({ data, marketerType, orderType, searchValue }) {
  const filteredData = useRecoilValue(crmFilteredTransaction);
  return (
    <InvoiceItemWrapper>
      {data && !filteredData
        ? data.pages.map((page) => {
            const queryDataOrder = orderType.map(
              (mode) => page?.data?.[`${mode}`]
            );
            const queryMarketerOrder = marketerType.map(
              (market) => page?.data?.[`${market}`]
            );

            const data = queryDataOrder.flat();
            const marketerdata = queryMarketerOrder.flat();

            return data
              ?.filter((user) => {
                if (searchValue === "") {
                  return user;
                } else if (
                  user.FirstName ? user.FirstName.includes(searchValue) : ""
                ) {
                  return user;
                } else if (
                  user.LastName ? user.LastName.includes(searchValue) : ""
                ) {
                  return user;
                }
              })
              .map((item, index) => {
                console.log(item);
                return (
                  <div className="invoice row" key={index}>
                    <div className="status col-lg-1 col-md-1 col-1 p-0 d-flex justify-content-center">
                      <IoCheckmarkDoneOutline
                        className="icon"
                        color={
                          item.IdOrderOnline &&
                          item.DepositAll !== 0 &&
                          item.DepositAll !== null
                            ? "#27a644"
                            : item.IdOrderOffline
                            ? "#17a2b8"
                            : item.IdOrderOfflineUnsuccessful
                            ? "#dc3847"
                            : item.DepositAll === 0 &&
                              item.IdOrderOnline &&
                              item.DepositAll !== null
                            ? "#f4b806"
                            : "#000"
                        }
                      />
                    </div>
                    <div className="main-content col-lg-7 col-md-6 col-6">
                      <Typogaphy>برچسب: {item?.FactorTag}</Typogaphy>
                      <Link
                        to={`/dashboard/crm/customer-file/${item.IdS0alesOpportunities}`}
                      >
                        <Typogaphy
                          size="16px"
                          primary={
                            item.IdOrderOnline &&
                            item.DepositAll !== 0 &&
                            item.DepositAll !== null
                              ? "#27a644"
                              : item.IdOrderOffline
                              ? "#17a2b8"
                              : item.IdOrderOfflineUnsuccessful
                              ? "#dc3847"
                              : item.DepositAll === 0 &&
                                item.IdOrderOnline &&
                                item.DepositAll !== null
                              ? "#f4b806"
                              : "#000"
                          }
                        >
                          {item.FirstName + " " + item.LastName}
                        </Typogaphy>
                      </Link>
                      <Typogaphy size="16px">
                        تاریخ: {MiladiToShamsi(item.created_at)}
                      </Typogaphy>
                      {marketerdata.map((marketer, index) => {
                        return (
                          <Fragment key={index}>
                            {marketer.IdOrderOnline &&
                            marketer.IdOrderOnline === item.IdOrderOnline ? (
                              <Typogaphy>
                                {"مسئول: " +
                                  marketer.FirstName +
                                  " " +
                                  marketer.LastName}
                              </Typogaphy>
                            ) : marketer.IdOrderOffline &&
                              marketer.IdOrderOffline ===
                                item.IdOrderOffline ? (
                              <Typogaphy>
                                {"مسئول: " +
                                  marketer.FirstName +
                                  " " +
                                  marketer.LastName}
                              </Typogaphy>
                            ) : marketer.IdOrderOfflineUnsuccessful &&
                              marketer.IdOrderOfflineUnsuccessful ===
                                item.IdOrderOfflineUnsuccessful ? (
                              <Typogaphy>
                                {"مسئول: " +
                                  marketer.FirstName +
                                  " " +
                                  marketer.LastName}
                              </Typogaphy>
                            ) : null}
                          </Fragment>
                        );
                      })}
                      {/* {findMarketer(item)} */}
                    </div>
                    <div className="price col-lg-4 col-md-5 col-5 d-block text-center">
                      <Typogaphy
                        primary={
                          item.IdOrderOnline &&
                          item.DepositAll !== 0 &&
                          item.DepositAll !== null
                            ? "#27a644"
                            : item.IdOrderOffline
                            ? "#17a2b8"
                            : item.IdOrderOfflineUnsuccessful
                            ? "#dc3847"
                            : item.DepositAll === 0 &&
                              item.IdOrderOnline &&
                              item.DepositAll !== null
                            ? "#f4b806"
                            : "#000"
                        }
                      >
                        مبلغ کل :{" "}
                        {item.PriceAll ? item.PriceAll.toLocaleString() : 0}{" "}
                        تومان
                      </Typogaphy>

                      <Typogaphy
                        primary={
                          item.IdOrderOnline &&
                          item.DepositAll !== 0 &&
                          item.DepositAll !== null
                            ? "#27a644"
                            : item.IdOrderOffline
                            ? "#17a2b8"
                            : item.IdOrderOfflineUnsuccessful
                            ? "#dc3847"
                            : item.DepositAll === 0 &&
                              item.IdOrderOnline &&
                              item.DepositAll !== null
                            ? "#f4b806"
                            : "#000"
                        }
                      >
                        مبلغ پرداختی :{" "}
                        {item.PriceAll ? item?.DepositAll?.toLocaleString() : 0}{" "}
                        تومان
                      </Typogaphy>
                      {item.IdOrderOffline ||
                      item.IdOrderOfflineUnsuccessful ? (
                        <Link
                          to={`/factor/${item.IdEquivalentOrderOffline}?factor=true`}
                        >
                          <Button
                            size="14px"
                            bgColor="#009ef7"
                            color="#fff"
                            small="fit-content"
                          >
                            نمایش فاکتور
                          </Button>
                        </Link>
                      ) : item.IdOrderOnline ? (
                        <Link
                          to={`/dashboard/accounting/orders/all/${item.IdOrderOnline}`}
                        >
                          <Button
                            size="14px"
                            bgColor="#009ef7"
                            color="#fff"
                            small="fit-content"
                          >
                            نمایش فاکتور
                          </Button>
                        </Link>
                      ) : null}
                    </div>
                  </div>
                );
              });
          })
        : filteredData && data
        ? filteredData.pages.map((page) => {
            const queryDataOrder = orderType.map(
              (mode) => page?.data?.[`${mode}`]
            );
            const queryMarketerOrder = marketerType.map(
              (market) => page?.data?.[`${market}`]
            );

            const data = queryDataOrder.flat();
            const marketerdata = queryMarketerOrder.flat();

            return data
              ?.filter((username) => {
                if (searchValue === "") {
                  return username;
                } else if (
                  username.FirstName
                    ? username.FirstName.includes(searchValue)
                    : ""
                ) {
                  return username;
                } else if (
                  username.LastName
                    ? username.LastName.includes(searchValue)
                    : ""
                ) {
                  return username;
                }
              })
              .map((item, index) => (
                <div className="invoice row" key={index}>
                  <div className="status col-lg-1 col-md-1 col-1 p-0 d-flex justify-content-center">
                    <IoCheckmarkDoneOutline
                      className="icon"
                      color={
                        item.IdOrderOnline &&
                        item.DepositAll !== 0 &&
                        item.DepositAll !== null
                          ? "#27a644"
                          : item.IdOrderOffline
                          ? "#17a2b8"
                          : item.IdOrderOfflineUnsuccessful
                          ? "#dc3847"
                          : item.DepositAll === 0 &&
                            item.IdOrderOnline &&
                            item.DepositAll !== null
                          ? "#f4b806"
                          : "#000"
                      }
                    />
                  </div>
                  <div className="main-content col-lg-7 col-md-6 col-6">
                    <Typogaphy>برچسب: {item?.FactorTag}</Typogaphy>
                    <Link
                      to={`/dashboard/crm/customer-file/${item.IdS0alesOpportunities}`}
                    >
                      <Typogaphy
                        size="16px"
                        primary={
                          item.IdOrderOnline &&
                          item.DepositAll !== 0 &&
                          item.DepositAll !== null
                            ? "#27a644"
                            : item.IdOrderOffline
                            ? "#17a2b8"
                            : item.IdOrderOfflineUnsuccessful
                            ? "#dc3847"
                            : item.DepositAll === 0 &&
                              item.IdOrderOnline &&
                              item.DepositAll !== null
                            ? "#f4b806"
                            : "#000"
                        }
                      >
                        {item.FirstName + " " + item.LastName}
                      </Typogaphy>
                    </Link>
                    <Typogaphy size="16px">
                      تاریخ: {MiladiToShamsi(item.created_at)}
                    </Typogaphy>
                    {marketerdata.map((marketer, index) => {
                      return (
                        <Fragment key={index}>
                          {marketer.IdOrderOnline &&
                          marketer.IdOrderOnline === item.IdOrderOnline ? (
                            <Typogaphy>
                              {"مسئول: " +
                                marketer.FirstName +
                                " " +
                                marketer.LastName}
                            </Typogaphy>
                          ) : marketer.IdOrderOffline &&
                            marketer.IdOrderOffline === item.IdOrderOffline ? (
                            <Typogaphy>
                              {"مسئول: " +
                                marketer.FirstName +
                                " " +
                                marketer.LastName}
                            </Typogaphy>
                          ) : marketer.IdOrderOfflineUnsuccessful &&
                            marketer.IdOrderOfflineUnsuccessful ===
                              item.IdOrderOfflineUnsuccessful ? (
                            <Typogaphy>
                              {"مسئول: " +
                                marketer.FirstName +
                                " " +
                                marketer.LastName}
                            </Typogaphy>
                          ) : null}
                        </Fragment>
                      );
                    })}
                    {/* {findMarketer(item)} */}
                  </div>
                  <div className="price col-lg-4 col-md-5 col-5 d-block text-center">
                    <Typogaphy
                      primary={
                        item.IdOrderOnline &&
                        item.DepositAll !== 0 &&
                        item.DepositAll !== null
                          ? "#27a644"
                          : item.IdOrderOffline
                          ? "#17a2b8"
                          : item.IdOrderOfflineUnsuccessful
                          ? "#dc3847"
                          : item.DepositAll === 0 &&
                            item.IdOrderOnline &&
                            item.DepositAll !== null
                          ? "#f4b806"
                          : "#000"
                      }
                    >
                      مبلغ کل :{" "}
                      {item.PriceAll ? item.PriceAll.toLocaleString() : 0} تومان
                    </Typogaphy>

                    <Typogaphy
                      primary={
                        item.IdOrderOnline &&
                        item.DepositAll !== 0 &&
                        item.DepositAll !== null
                          ? "#27a644"
                          : item.IdOrderOffline
                          ? "#17a2b8"
                          : item.IdOrderOfflineUnsuccessful
                          ? "#dc3847"
                          : item.DepositAll === 0 &&
                            item.IdOrderOnline &&
                            item.DepositAll !== null
                          ? "#f4b806"
                          : "#000"
                      }
                    >
                      مبلغ پرداختی :{" "}
                      {item.PriceAll ? item?.DepositAll?.toLocaleString() : 0}{" "}
                      تومان
                    </Typogaphy>
                    {item.IdOrderOffline || item.IdOrderOfflineUnsuccessful ? (
                      <Link
                        to={`/factor/${item.IdEquivalentOrderOffline}?factor=true`}
                      >
                        <Button
                          size="14px"
                          bgColor="#009ef7"
                          color="#fff"
                          small="fit-content"
                        >
                          نمایش فاکتور
                        </Button>
                      </Link>
                    ) : item.IdOrderOnline ? (
                      <Link
                        to={`/dashboard/accounting/orders/all/${item.IdOrderOnline}`}
                      >
                        <Button
                          size="14px"
                          bgColor="#009ef7"
                          color="#fff"
                          small="fit-content"
                        >
                          نمایش فاکتور
                        </Button>
                      </Link>
                    ) : null}
                  </div>
                </div>
              ));
          })
        : null}
    </InvoiceItemWrapper>
  );
}
export default InvoiceItem;
